import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { PortalAuthService } from '../auth/portal-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const apiBaseUrl = environment.apiBaseUrl;

  // Nunca anexar token de autenticação em requisições fora da API — evita
  // vazar o Bearer token para domínios de terceiros (ex.: CDNs, analytics).
  if (!req.url.startsWith(apiBaseUrl)) {
    return next(req);
  }

  const path = req.url.slice(apiBaseUrl.length);

  const internalPublicAuthEndpoints = [
    '/auth/login',
    '/auth/request-password-reset',
    '/auth/validate-password-reset-token',
    '/auth/reset-password',
  ];
  const portalPublicAuthEndpoints = [
    '/cliente/auth/login',
    '/cliente/auth/request-password-reset',
    '/cliente/auth/validate-token',
    '/cliente/auth/redeem-token',
  ];

  const isInternalPublicAuth = internalPublicAuthEndpoints.some((endpoint) => path === endpoint);
  const isPortalPublicAuth = portalPublicAuthEndpoints.some((endpoint) => path === endpoint);

  if (isInternalPublicAuth || isPortalPublicAuth) {
    return next(req);
  }

  if (path.startsWith('/client-portal/') || path.startsWith('/cliente/')) {
    const portalAuth = inject(PortalAuthService);
    const portalToken = portalAuth.getToken();

    if (!portalToken) {
      return next(req);
    }

    return next(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${portalToken}`
        }
      })
    );
  }

  const auth = inject(AuthService);
  const token = auth.getToken();

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })
  );
};
